__turbopack_context__.v({
  "word": "revealTitle-module-scss-module__5G86CG__word",
  "wrapper": "revealTitle-module-scss-module__5G86CG__wrapper",
});
